var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tr",
    [
      (_vm.create && !_vm.value.id) || _vm.edit || _vm.bulk
        ? [
            _c("td", { attrs: { colspan: _vm.colspan } }, [
              _c("div", { staticClass: "card" }, [
                _c(
                  "div",
                  { staticClass: "card-header" },
                  [
                    _vm.create
                      ? [_vm._v("Add Student")]
                      : [
                          _vm._v(
                            "Editing Student " + _vm._s(_vm.student.firstName)
                          )
                        ]
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "card-body" }, [
                  _c(
                    "div",
                    { staticClass: "row" },
                    _vm._l(_vm.fields, function(property, field) {
                      return _c(
                        "div",
                        { staticClass: "col-sm-3" },
                        [
                          field == "classId"
                            ? [
                                _c(
                                  "label",
                                  { attrs: { for: "students-edit-classid" } },
                                  [_vm._v(_vm._s(_vm.labels["classId"]))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model.number",
                                        value: _vm.student.classId,
                                        expression: "student.classId",
                                        modifiers: { number: true }
                                      }
                                    ],
                                    staticClass: "form-control",
                                    class: {
                                      "is-invalid": _vm.hasError(field)
                                    },
                                    attrs: {
                                      id: "students-edit-classid",
                                      required: _vm.isEnabled(
                                        "classId.required"
                                      ),
                                      disabled: !_vm.isEnabled(field)
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return _vm._n(val)
                                          })
                                        _vm.$set(
                                          _vm.student,
                                          "classId",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("option", { domProps: { value: null } }),
                                    _vm._v(" "),
                                    _vm._l(_vm.classes, function(schoolClass) {
                                      return _c(
                                        "option",
                                        { domProps: { value: schoolClass.id } },
                                        [_vm._v(_vm._s(schoolClass.name))]
                                      )
                                    })
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.errorMessage(field)) +
                                      "\n                "
                                  )
                                ])
                              ]
                            : field == "gender"
                            ? [
                                _c(
                                  "label",
                                  { attrs: { for: "students-edit-gender" } },
                                  [_vm._v(_vm._s(_vm.labels["gender"]))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model.number",
                                        value: _vm.student.gender,
                                        expression: "student.gender",
                                        modifiers: { number: true }
                                      }
                                    ],
                                    staticClass: "form-control",
                                    class: {
                                      "is-invalid": _vm.hasError(field)
                                    },
                                    attrs: {
                                      id: "students-edit-gender",
                                      required: _vm.isEnabled(
                                        "gender.required"
                                      ),
                                      disabled: !_vm.isEnabled(field)
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return _vm._n(val)
                                          })
                                        _vm.$set(
                                          _vm.student,
                                          "gender",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("option", { attrs: { value: "" } }),
                                    _vm._v(" "),
                                    _vm._l(_vm.genders, function(
                                      value,
                                      gender
                                    ) {
                                      return _c(
                                        "option",
                                        { domProps: { value: gender } },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(value) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    })
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.errorMessage(field)) +
                                      "\n                "
                                  )
                                ])
                              ]
                            : field == "exemption"
                            ? [
                                _c(
                                  "label",
                                  { attrs: { for: "students-edit-exemption" } },
                                  [_vm._v(_vm._s(_vm.labels["exemption"]))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model.number",
                                        value: _vm.student.exemption,
                                        expression: "student.exemption",
                                        modifiers: { number: true }
                                      }
                                    ],
                                    staticClass: "form-control",
                                    class: {
                                      "is-invalid": _vm.hasError(field)
                                    },
                                    attrs: {
                                      id: "students-edit-exemption",
                                      required: _vm.isEnabled(
                                        "exemption.required"
                                      ),
                                      disabled: !_vm.isEnabled(field)
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return _vm._n(val)
                                          })
                                        _vm.$set(
                                          _vm.student,
                                          "exemption",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("option", { attrs: { value: "" } }),
                                    _vm._v(" "),
                                    _vm._l(_vm.exemptions, function(
                                      value,
                                      exemption
                                    ) {
                                      return _c(
                                        "option",
                                        { domProps: { value: exemption } },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(value) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    })
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.errorMessage(field)) +
                                      "\n                "
                                  )
                                ])
                              ]
                            : [
                                _c(
                                  "label",
                                  { attrs: { for: "students-edit-" + field } },
                                  [_vm._v(_vm._s(_vm.labels[field]))]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.student[field],
                                      expression: "student[field]"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: { "is-invalid": _vm.hasError(field) },
                                  attrs: {
                                    type: "text",
                                    id: "students-edit-" + field,
                                    required: _vm.isEnabled(
                                      field + ".required"
                                    ),
                                    disabled: !_vm.isEnabled(field),
                                    placeholder: _vm.value[field]
                                  },
                                  domProps: { value: _vm.student[field] },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.student,
                                        field,
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.errorMessage(field)) +
                                      "\n                "
                                  )
                                ])
                              ]
                        ],
                        2
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  !_vm.bulk
                    ? _c("div", { staticClass: "text-right mt-sm-2" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-sm btn-outline-secondary",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.closeForm()
                              }
                            }
                          },
                          [_vm._v("\n              Close\n            ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-sm btn-outline-success",
                            attrs: { type: "submit" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.save.apply(null, arguments)
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "fas fa-fw",
                              class: _vm.saving
                                ? "fa-spinner fa-pulse"
                                : "fa-save"
                            }),
                            _vm._v(" Save\n            ")
                          ]
                        )
                      ])
                    : _vm._e()
                ])
              ])
            ])
          ]
        : _vm.view
        ? [
            _c(
              "td",
              { attrs: { colspan: "10" } },
              [
                _c("view-student", {
                  attrs: {
                    fields: _vm.fields,
                    labels: _vm.labels,
                    classes: _vm.classes,
                    genders: _vm.genders,
                    exemptions: _vm.exemptions,
                    school: _vm.school
                  },
                  on: { cancel: _vm.cancel },
                  model: {
                    value: _vm.value,
                    callback: function($$v) {
                      _vm.value = $$v
                    },
                    expression: "value"
                  }
                })
              ],
              1
            )
          ]
        : [
            _vm._l(_vm.filteredFields, function(property, field) {
              return _c("td", [
                field == "classId"
                  ? _c("span", [_vm._v(_vm._s(_vm.className))])
                  : _vm.totalFields > _vm.colspan && field == "firstName"
                  ? _c("span", [
                      _c(
                        "a",
                        {
                          attrs: { href: "" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              _vm.view = true
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.value[field]))]
                      )
                    ])
                  : _c("span", [_vm._v(_vm._s(_vm.value[field]))])
              ])
            }),
            _vm._v(" "),
            _c("th", { staticClass: "text-right float-right" }, [
              _vm.canDeleteStudent
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-outline-secondary",
                      attrs: { type: "button", "aria-label": "Delete" },
                      on: {
                        click: function($event) {
                          return _vm.destroy(_vm.value)
                        }
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "fas fa-fw",
                        class:
                          _vm.deleting === _vm.value
                            ? "fa-spinner fa-pulse"
                            : "fa-trash"
                      })
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.canEditStudent
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-outline-secondary open-form",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.onEdit()
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fas fa-fw fa-edit" }),
                      _vm._v(" Edit\n      ")
                    ]
                  )
                : _vm._e()
            ])
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-eadba8a6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eadba8a6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/student-form.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-eadba8a6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/student-form.vue
// module chunks = 0